import Vue from 'vue'
import Router from 'vue-router'
import LoginRouter from './login/index'
import AppRouter from './app/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    ...LoginRouter,
    ...AppRouter
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js